export { default } from './TrailAvatar';
